import { render, staticRenderFns } from "./CardRegion.vue?vue&type=template&id=2fb908fe&scoped=true"
import script from "./CardRegion.vue?vue&type=script&lang=js"
export * from "./CardRegion.vue?vue&type=script&lang=js"
import style0 from "./CardRegion.vue?vue&type=style&index=0&id=2fb908fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb908fe",
  null
  
)

export default component.exports